// Define interfaces for type safety
export interface ColorOption {
  value: string;
  label: string;
  color: string;
  rgb: [number, number, number];
}

export type ColorType = 'boundaryColor' | 'polygonColor';
export type DropdownType = 'boundary' | 'polygon';

// Color options configuration
export const COLOR_OPTIONS: ColorOption[] = [
  { value: '', label: 'None', color: 'transparent', rgb: [0, 0, 0] },
  { value: 'primary', label: 'Primary', color: '#007bff', rgb: [0, 123, 255] },
  { value: 'warning', label: 'Warning', color: '#ffc107', rgb: [255, 193, 7] },
  { value: 'danger', label: 'Danger', color: '#dc3545', rgb: [220, 53, 69] },
];

// Helper function to get selected color option
export const getSelectedColor = (value: string): ColorOption => {
  return (
    COLOR_OPTIONS.find(option => option.value === value) || COLOR_OPTIONS[0]
  );
};

export const getColorValue = (colorName: string): [number, number, number] => {
  const colorOption = COLOR_OPTIONS.find(option => option.value === colorName);
  return colorOption?.rgb || [0, 0, 0];
};

// Handle color selection
export const handleColorSelect =
  (
    onNoteChange: (type: ColorType, value: string) => void,
    setBoundaryOpen: (value: boolean) => void,
    setPolygonOpen: (value: boolean) => void,
  ) =>
  (type: ColorType, value: string): void => {
    onNoteChange(type, value);
    if (type === 'boundaryColor') {
      setBoundaryOpen(false);
    } else {
      setPolygonOpen(false);
    }
  };

// Handle dropdown toggle
export const handleDropdownToggle =
  (
    setBoundaryOpen: (value: boolean | ((prev: boolean) => boolean)) => void,
    setPolygonOpen: (value: boolean | ((prev: boolean) => boolean)) => void,
  ) =>
  (type: DropdownType): void => {
    if (type === 'boundary') {
      setBoundaryOpen(prev => !prev);
      setPolygonOpen(false);
    } else {
      setPolygonOpen(prev => !prev);
      setBoundaryOpen(false);
    }
  };
